export default __webpack_public_path__ + "static/media/ch-3.a85ed0b1.png";